import palette from '../palette';
import typography from '../typography';

export default {
  styleOverrides: {
    root: {
      ...typography.body1,
      borderBottom: `1px solid ${palette.divider}`,
    },
    head: {
      ...typography.body1,
      lineHeight: '24px',
      borderBottom: `1px solid ${palette.divider}`,
      padding: '16px',
      '&.MuiTableCell-paddingCheckbox': {
        padding: '0 0 0 4px',
      },
      '&.MuiTableCell-sizeMedium': {
        padding: '16px',
        '&.MuiTableCell-paddingCheckbox': {
          padding: '0 0 0 4px',
        },
      },
    },
    body: {
      ...typography.body1,
      borderBottom: `1px solid ${palette.divider}`,
      padding: '16px',
      '&.MuiTableCell-paddingCheckbox': {
        padding: '0 0 0 4px',
      },
    },
    sizeMedium: {
      ...typography.body1,
      borderBottom: `1px solid ${palette.divider}`,
      padding: '16px',
      '&.MuiTableCell-head': {
        lineHeight: '24px',
      },
      '&.MuiTableCell-paddingCheckbox': {
        padding: '0 0 0 4px',
      },
    },
  },
};
